import React from "react";
import styled from "styled-components";

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  z-index: 100;
  border: 1px solid #dadce0;
`;

const Placeholder = styled.p`
  font-family: Inter, system-ui;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  color: #84838d;
  margin-top: 100px;
`;

const EmptyGridOverlay = () => (
  <Container>
    <Placeholder>
      Select fields from the dropdown above to start creating your report.
      <br />
      Deal Name will always be displayed.
    </Placeholder>
  </Container>
);

export default EmptyGridOverlay;
